import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { IdentityStash } from '../stash';
import { AuthService } from '../service';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    private readonly platformId = inject(PLATFORM_ID);

    constructor(
        private readonly router: Router,
        private readonly authService: AuthService,
        private readonly identityStash: IdentityStash
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const isBrowser = isPlatformBrowser(this.platformId);

        if (isBrowser) {
            const identity = this.identityStash.fetch();
            if (identity?.token) {
                return true;
            }
        }

        return this.authService.refresh()
            .pipe(
                map(identity => {
                    return identity?.token ? true : this.router.createUrlTree(['/login']);
                })
            );
    }
}
